var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5875 17.9489L15.1771 13.5385C16.2389 12.1249 16.8121 10.4043 16.8102 8.63629C16.8102 4.12035 13.1361 0.446289 8.62018 0.446289C4.10424 0.446289 0.430176 4.12035 0.430176 8.63629C0.430176 13.1522 4.10424 16.8263 8.62018 16.8263C10.3882 16.8282 12.1088 16.255 13.5224 15.1932L17.9328 19.6036C18.1561 19.8032 18.4473 19.9097 18.7466 19.9014C19.046 19.893 19.3307 19.7703 19.5425 19.5586C19.7542 19.3468 19.8769 19.0621 19.8853 18.7627C19.8936 18.4634 19.7871 18.1722 19.5875 17.9489ZM2.77018 8.63629C2.77018 7.47927 3.11327 6.34823 3.75608 5.3862C4.39889 4.42418 5.31253 3.67437 6.38148 3.23159C7.45043 2.78882 8.62667 2.67297 9.76146 2.8987C10.8962 3.12442 11.9386 3.68158 12.7568 4.49971C13.5749 5.31785 14.132 6.36022 14.3578 7.49501C14.5835 8.6298 14.4676 9.80604 14.0249 10.875C13.5821 11.9439 12.8323 12.8576 11.8703 13.5004C10.9082 14.1432 9.7772 14.4863 8.62018 14.4863C7.06923 14.4844 5.58234 13.8675 4.48566 12.7708C3.38897 11.6741 2.77204 10.1872 2.77018 8.63629Z",
    fill: "#FECD06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScg);
export default __webpack_public_path__ + "static/media/scg.8ef71e75020f17ef80851dddf0afecfd.svg";
export { ForwardRef as ReactComponent };